import { Outlet } from "react-router-dom";

export function AuthLayout() {
  return (
    <div className="flex h-dvh flex-col overflow-hidden bg-background pb-[env(safe-area-inset-bottom)]">
      <main className="min-h-0 flex-1">
        <Outlet />
      </main>
    </div>
  );
}
